import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Polygon,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Polygon, { points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "22", x2: "16", y1: "9", y2: "15", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "16", x2: "22", y1: "9", y2: "15", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "VolumeX";
const VolumeX = memo(themed(Icon));
export {
  VolumeX
};
//# sourceMappingURL=volume-x.js.map
